import ShowcaseEmbed from "./EmbedShowcase";

function GameSectionFallback() {
    return (
        <>
            <ShowcaseEmbed 
                Title='Rocket Joyride' 
                Date="June 18 - June 25, 2025"
                ButtonURL='https://brianthedevguy.itch.io/rocket-joyride-1-week'
                ButtonText='Play on Itch.io'
                EmbedCode={(<iframe title='Rocket Joyride' frameborder="0" src="https://itch.io/embed/3749437?bg_color=f0f8ff&amp;link_color=2f4f4f&amp;border_color=2f4f4f" width="552" height="167"><a href="https://brianthedevguy.itch.io/rocket-joyride-1-week">Rocket Joyride 1 Week by BrianTheDevGuy</a></iframe>)}
            >
                <p>
                    A retro 2D style arcade game that tests your reflexes,
                    where you avoid hazards in space to get as far as possible.
                    You play as a rocket flying through space, collecting coins,
                    and avoiding hazards like asteroids, commets, or even UFOs
                </p>
                <p>
                    This game was created for the&nbsp;
                    <a href='https://itch.io/jam/california-uni-summer-game-jam'>Uni Game Jam</a>&nbsp;
                    Where I submitted this for the 48 hour game jam and for the week long game jam.
                </p>
                <p>
                    This game is avalible on <a href='https://brianthedevguy.itch.io/rocket-joyride-1-week'>itch.io</a>.
                    Where you can play the <a href='https://brianthedevguy.itch.io/rocket-joyride'>48 Hour</a>&nbsp;
                    version or the <a href='https://brianthedevguy.itch.io/rocket-joyride-1-week'>Week long</a> version
                </p>
                <p>*Play on browser (PC & Mobile) or Download for Windows</p>
                <code>
                    This Project Uses C# and Unity Game Engine
                </code>
            </ShowcaseEmbed>
            <hr/>
            <ShowcaseEmbed 
                Title="Oisin's Lovely Day" 
                Date="March 27 - March 30, 2024"
                ButtonURL='https://brianthedevguy.itch.io/oisins-lovely-day'
                ButtonText='Download on Itch.io'
                EmbedCode={(<iframe title="Oisin's Lovely Day" frameborder="0" src="https://itch.io/embed/3436329?bg_color=f0f8ff&amp;link_color=2f4f4f&amp;border_color=2f4f4f" width="552" height="167"><a href="https://brianthedevguy.itch.io/oisins-lovely-day">Oisin's  Lovely Day by BrianTheDevGuy</a></iframe>)}
                EmbedOnLeft={true}
            >
                <p>
                    A pixel art 2D platformer game with colorful visuials,
                    indicating that Spring Time is here! But there is one problem.
                    Oisin has lost his gold! It must have been those pesky goblins!
                    Help Oisin find his pot of gold while avoiding those evil goblins!
                </p>
                <p>
                    This game is avalible on <a href='https://brianthedevguy.itch.io/oisins-lovely-day'>itch.io</a>.
                </p>
                <p>*Only avalible for Download on Windows</p>
                <code>
                    This Project Uses C# and Unity Game Engine
                </code>
            </ShowcaseEmbed>
            <hr/>
            <ShowcaseEmbed 
                Title='Witch Night, Was it?' 
                Date="October 18 - October 19, 2024"
                ButtonURL='https://brianthedevguy.itch.io/witch-day-was-it'
                ButtonText='Download on Itch.io'
                EmbedCode={(<iframe title="Witch Night, Was it?" frameborder="0" src="https://itch.io/embed/3050519?bg_color=f0f8ff&amp;link_color=2f4f4f&amp;border_color=2f4f4f" width="552" height="167"><a href="https://brianthedevguy.itch.io/witch-day-was-it">Witch day, was it? by BrianTheDevGuy</a></iframe>)}
            >
                <p>
                    This was my First Game Jam. I joined the Horror Game Jam where I created
                    a spooky 3D horror game. You are in the woods where a witch is known to live at.
                    Tonight is Witch Night, when the witch brews her wicked potions.
                    You have to twart the witches plans by destroying her cauldrons, and putting an end to
                    her malicious deeds
                </p>
                <p>
                    This game is avalible on <a href='https://brianthedevguy.itch.io/witch-day-was-it'>itch.io</a>.
                </p>
                <p> *Only avalible for Download on Windows</p>
                <code>
                    This Project Uses C# and Unity Game Engine
                </code>
            </ShowcaseEmbed>
        </>
    );
}
export default GameSectionFallback